import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type React from 'react'

export type StepState = 'completed' | 'in-progress' | 'pending'

interface StepProps {
  step: number
  title: string
  description: string | React.ReactNode
  status: StepState
  children?: React.ReactNode
}

const Step: React.FC<StepProps> = ({
  step,
  title,
  description,
  status,
  children,
}) => {
  const statusStyle = () => {
    switch (status) {
      case 'in-progress':
        return ''
      case 'completed':
        return 'line-through opacity-50 text-brand-light-text-description'

      case 'pending':
        return 'opacity-40'
    }
  }

  return (
    // Stack the action button beneath the text on mobile so a long button
    // label (e.g. "Re-use my Veli verification") can't squeeze the title and
    // description into a thin, badly-wrapping column. Inline on sm+.
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 shrink-0 ">
          {status === 'completed' ? (
            <div className="w-full h-full flex items-center justify-center">
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-[#2E9E6B] h-5 w-5"
              />
            </div>
          ) : (
            <div
              className={`w-full h-full border-[1px] ${
                status === 'in-progress'
                  ? 'border-black/10 dark:border-white/20 border-solid'
                  : ''
              } rounded-full bg-slate-100 dark:bg-brand-dark-background flex items-center justify-center font-semi ${statusStyle()}`}
            >
              {step}
            </div>
          )}
        </div>
        <div className={`${statusStyle()}`}>
          <p className="font-semi text-[0.80rem]">{title}</p>
          <p className="text-description">{description}</p>
        </div>
      </div>
      {status === 'in-progress' && (
        <div className="w-full pl-14 sm:w-auto sm:shrink-0 sm:self-center sm:pl-0 sm:ml-5">
          {children}
        </div>
      )}
    </div>
  )
}

export default Step
